import { useState, useEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';

import ShortFiler from '../../../../../types/filers/shortFiler';
import RecentlyOrganizedTable from './RecentlyOrganizedTable';
import { Box } from '@mui/material';

interface Props {
    tpye: string;
    officeName?: string;
}

const CommitteeList = (props:Props): JSX.Element => {

    const [filers, setFilers] = useState<ShortFiler[]>([]);
    const { showBoundary } = useErrorBoundary();  

    useEffect(() => {
        getRecentlyOrganized();
    }, [props.tpye, props.officeName])

    const getRecentlyOrganized = async () => {

        try{
            await fetch(`${process.env.REACT_APP_API_BASE_URL}/filers/recentlyOrganized/${props.tpye}?officeFilter=${props.officeName??''}`)
            .then(result => {
                if (!result.ok) {
                    showBoundary(new Error('Failed to get recently organized candidate list.'));
                }
                return result.json();
            })
            .then(result => {
                let filers: ShortFiler[] = result;
                setFilers(filers);
                return;
            });
        }catch(error)
        {
            console.error('Uncaught Error:', error);
        }
    }

    
    return (
        <Box marginTop={4}>
            <RecentlyOrganizedTable filers={filers} type={props.tpye}></RecentlyOrganizedTable>
        </Box>
    )
}

export default CommitteeList;